import moment from 'moment';
import countries from '../data/countries.json'
import occupations from '../data/occupation-group.json'

export const sortData = (data, filter = '') => {

    let sorted = [];

    if (filter !== '') {

        sorted = data.sort((a, b) => {
            if (a[filter].toString() < b[filter].toString()) { return -1 }
            else if (a[filter].toString() > b[filter].toString()) { return 1 }
            else { return 0 }
        })

    }

    if (filter === '') {

        sorted = data.sort((a, b) => {
            if (a.toString() < b.toString()) { return -1 }
            else if (a.toString() > b.toString()) { return 1 }
            else { return 0 }
        })

    }

    return sorted;
}

export const getCountries = () => {

    let result = countries;
    result = sortData(result, 'name');
    return result

}

export const occupationGroups = () => {

    let result = occupations;
    result = sortData(result, 'name');
    return result

}

export const generate = (size = 6, isAlpha) => {

    const pool = isAlpha ? 'ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789abcdefghijklmnpqrstuvwxyz' : '1234567890'
    const rand = []
    let i = -1

    while (++i < size) {
        rand.push(pool.charAt(Math.floor(Math.random() * pool.length)))
    }

    return rand.join('')

}

export const convertToTitleCase = (arr) => {
    return arr.map(str => {
        return str
            // Add a space before each uppercase letter (except the first one)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize the first letter of each word
            .replace(/\b\w/g, char => char.toUpperCase());
    });
}

// Generic per-value fallback used when a column doesn't supply its own `format`:
// booleans become YES/NO, arrays become their length, and populated refs ({ title }) show their title.
const defaultCsvFormat = (value) => {
    if (typeof value === 'boolean') return value ? 'YES' : 'NO';
    if (Array.isArray(value)) return value.length;
    if (value && typeof value === 'object' && value.title) return value.title;
    return value;
};

/**
 * Convert an array of objects into a CSV string and trigger a download.
 *
 * @param {Array<Object>} data - The rows to export.
 * @param {string} filename - The name of the file to download (e.g., 'report.csv').
 * @param {Array<{key: string, header: string, format?: (row: Object) => any}>} columns -
 *   Column definitions in output order. `format`, when given, receives the raw row and
 *   returns the cell value; otherwise `row[key]` is used, passed through `defaultCsvFormat`.
 */
export const exportToCsv = (data, filename, columns) => {
    if (!data || data.length === 0) {
        console.warn("No data provided for CSV export.");
        return;
    }

    const headerRow = columns
        .map(column => `"${column.header}"`)
        .join(',');

    const dataRows = data.map(row => {
        const values = columns.map(column => {
            const raw = column.format ? column.format(row) : defaultCsvFormat(row[column.key]);
            const value = raw === null || raw === undefined ? '' : raw;
            const stringValue = String(value);
            return `"${stringValue.replace(/"/g, '""')}"`;
        });
        return values.join(',');
    }).join('\n');

    const csvString = [headerRow, dataRows].join('\n');

    try {
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Failed to generate or download CSV:", error);
    }
};

const PARTICIPANT_COLUMNS = [
    { key: 'surname', header: 'Surname', format: (s) => s.lastName },
    { key: 'firstName', header: 'First Name', format: (s) => s.firstName },
    { key: 'phone', header: 'Phone', format: (s) => s.phone },
    { key: 'email', header: 'Email', format: (s) => s.email },
    { key: 'regDate', header: 'Reg Date', format: (s) => moment.utc(s.createdAt).startOf('day').format("Do MMMM, YYYY") },
    { key: 'gender', header: 'Gender', format: (s) => s.gender },
    { key: 'occupationGroup', header: 'Occupation Group', format: (s) => s.occupationGroup },
    { key: 'occupation', header: 'Occupation', format: (s) => s.occupation },
    { key: 'maritalStatus', header: 'Marital Status', format: (s) => s.maritalStatus },
    { key: 'country', header: 'Country', format: (s) => s.country },
    { key: 'state', header: 'State', format: (s) => s.state },
    { key: 'town', header: 'Town', format: (s) => s.town },
];

export const newexportToCsv = (data, filename) => exportToCsv(data, filename, PARTICIPANT_COLUMNS);

